export default {
  getEngagement: (state) => state.engagement,
  getAttributions: (state) => state.attributions,
  getIsLoading: (state) => state.isLoading,
  getTimezone: (state) => state.timezone,
};
